export default __webpack_public_path__ + "41b5224bb6196a70f3f9a924d10d35dc.png";